import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { useSelector } from 'react-redux';

const { TextArea } = Input;

function TextAreaComponent({
  type,
  handleReason,
  isDisable,
  title,
  handleDelLim,
  characters,
  value,
  placeholder,
  height,
  projects,
  userWritePermission,
  homePermission,
  applyRegex,
  borderRadius,
  positionOpeningClass,
  reasonSpecialChar,
  countCharacters
}) {
  const RegExp = /^[A-Za-z\.\-\,\'\"\s]*$/;
  const themeMode = useSelector((state) => state.layout.themeMode);
  const [textValue, setTextValue] = useState('');
  const [errorSpace, setErrorSpace] = useState('');
  const [wordCount, setWordCount] = useState(0);

  const truncateStringToLength = (str, targetLength) => {
    if (str?.length <= targetLength) {
      return str; // Return the string as is if it's already within or equal to the target length
    } else {
      return str?.substring(0, targetLength); // Return a substring starting from index 0 to the target length
    }
  };
  useEffect(() => {
    let truncatedString = truncateStringToLength(value, characters);
    if (truncatedString) setTextValue(truncatedString);
  }, [value]);

  useEffect(() => {
    textValue !== undefined && setWordCount(textValue?.length || 0);
    if (!projects) {
      wordCount > characters
        ? (() => {
            handleDelLim(true);
          })()
        : (() => {
            handleDelLim(false);
          })();
    }
  }, [textValue]);

  const handleChange = (e) => {
    let { value } = e.target;
      const numericRegex = /[0-9]/;
      const specialCharsRegex = /[_=+`~\/!@;#$%^&*()[\]\\\?{}|<>]/;
    if (/^\s/.test(value)) {
      setErrorSpace(<span className="text-danger">Cannot start with a space!</span>);
      value = value.trimStart();
    } else if ((reasonSpecialChar && specialCharsRegex.test(value))) {
      setErrorSpace(<span className="text-danger">Special characters are not allowed!</span>);
      value = value.replace(specialCharsRegex, '');
    } else if ((reasonSpecialChar && numericRegex.test(value))) {
      setErrorSpace(<span className="text-danger">Numbers are not allowed!</span>);
    } else {
      setErrorSpace('');
      if (applyRegex && RegExp.test(value)) {
        setTextValue(value);
        handleReason(value);
        setWordCount(value.length);
      } else if (!applyRegex) {
        setTextValue(value);
        handleReason(value);
        setWordCount(value.length);
      }
    }
  };
  return (
    <div>
      {title && <h6>{title}</h6>}
      {isDisable ? (
        <TextArea
          placeholder={placeholder}
          className={`${positionOpeningClass && themeMode === 'light' ? 'noOfResources_input' : ''} ${
            positionOpeningClass && themeMode === 'dark' ? 'noOfResources_input_dark' : ''
          }`}
          style={{
            background: themeMode === 'light' ? 'white' : '',
            color: themeMode === 'dark' ? '#fff' : '#6e6b7b',
            resize: 'none',
            borderColor: themeMode === 'dark' ? '#fff' : '#98a0ae',
            borderRadius: borderRadius ? borderRadius : 'none',
            height: height,
          }}
          autoSize={true}
          rows={4}
          value={textValue}
          maxLength={characters}
          onChange={handleChange}
          disabled={isDisable}
        />
      ) : (
        <TextArea
          placeholder={placeholder}
          className={`${positionOpeningClass && themeMode === 'light' ? 'noOfResources_input' : ''} ${
            positionOpeningClass && themeMode === 'dark' ? 'noOfResources_input_dark' : ''
          }`}
          style={{
            background: themeMode === 'light' ? 'white' : '#0c1c33',
            color: themeMode === 'dark' ? '#fff' : '#6e6b7b',
            resize: 'none',
            borderColor: themeMode === 'dark' ? '#fff' : '#98a0ae',
            borderRadius: borderRadius ? borderRadius : 'none',
            height: height,
          }}
          disabled={
            userWritePermission !== undefined || homePermission !== undefined
              ? location.pathname === '/projects' && userWritePermission?.write
                ? false
                : location.pathname === '/projects' && userWritePermission?.write
                ? false
                : homePermission?.write
                ? false
                : true
              : false
          }
          rows={4}
          value={textValue}
          onChange={handleChange}
          maxLength={characters !== undefined ? characters : 300}
        />
      )}
      {type && type === 'ready-only' ? (
        ''
      ) : errorSpace !== '' ? (
        errorSpace
      ) : wordCount > characters ? (
        <span className="text-danger">Maximum {characters} characters are allowed!!</span>
      ) : (
        <span className="text-green">
          Characters: {wordCount}/{countCharacters ? countCharacters : characters}
        </span>
      )}
    </div>
  );
}

export default TextAreaComponent;
